import React, { FunctionComponent } from 'react';

import { PageProps } from 'gatsby';

import Swap from '../views/Swap';

const Page: FunctionComponent<
  PageProps & { pageContext: { locale: string } }
> = () => {
  return <Swap />;
};
export default Page;
